import React from 'react';
import Carousel2 from '../components/Carousel2';
import HomeButton from '../components/HomeButton';
import '../styles/Menu.css';

const Menu = () => {
    return (
        <div className="menu-hero">
            <HomeButton />
            
            {/* Carousel2 come sfondo */}
            <div className="menu-hero__bg">
                <Carousel2 />
            </div>
            
            {/* Contenuto sopra lo sfondo */}
            <div className="menu-hero__content">
                
                    <div className='MenuPranzo'>
                        menu pranzo
                    </div>
                    <div className='MenuCena'>
                        menu cena
                    </div>
                
            </div>
        </div>
    );
};

export default Menu;